import React, { Component, useState, useEffect } from "react";

import { connect } from "react-redux";

import {
  OutputType1,
  Tooltip_left,
  ButtonType7,
  Custom_modal,
  ButtonType5,
} from "@visualizeroi/vroi-custom-components";

import EmailOnlyModal from "./EmailOnlyModal";

import GroupButton from "./GroupButton";
import RenderChart from "./RenderChart";

import { Download_btn } from "./partial/Icons";

const OutputsView = (props: any) => {
  const {
    outputs,
    hide_outputs,
    setAssumption_modal,
    variables_details,
    currency_conversion_rate,
    currency_sign,
    setUser_modal,
    inputs,
  } = props;

  const [emailModal, setEmailModal] = useState(false);

  const [active, setActive] = useState("2");

  const handleGB = (e) => {
    setActive(e.target.getAttribute("data-value"));
  };

  const outputs_values = (code_ref, round = 0) => {
    let value = "0";
    if (outputs) {
      if (
        variables_details &&
        variables_details[code_ref] &&
        variables_details[code_ref].representation == "Currency"
      ) {
        value = props
          .decorate(
            code_ref,
            (outputs[code_ref] * currency_conversion_rate).toFixed(round)
          )
          .toLocaleString()
          .replace("$", currency_sign);
      } else {
        if (outputs[code_ref]) {
          value = props.decorate(code_ref, outputs[code_ref].toFixed(round));
        }
      }
    }
    return value;
  };

  return (
    <div>
      <div className="output_box">
        <div className="output_1_div">
          <div className="output_label">
            Total Savings Over {inputs && inputs["Term - 4ss6w"]} Years
          </div>
          <div className="output_var">
            {outputs_values("Savings Amount -OU")}
          </div>
        </div>

        <div className="chart_main_div">
          <RenderChart
            outputs={outputs}
            active={active}
            variables_details={variables_details}
            currency_conversion_rate={currency_conversion_rate}
            currency_sign={currency_sign}
          />
        </div>

        <div className="chart_footer"> TCO Comparison Based on Your Input </div>
        <div className="btn_main_div">
          <button
            type="button"
            className="download_btn"
            onClick={() => setUser_modal(true)}
          >
            Get The Full Report
          </button>
        </div>

        <div className="app_privacy">
          This is just an estimation and actual prices may vary. It does not
          sign you up for any services or provision any resources. Questions on
          pricing? <b>Email </b>{" "}
          <a href="mailto:savings@diamanti.com">
            <span>savings@diamanti.com</span>
          </a>
        </div>
      </div>
    </div>
  );
};

function mapStateToProps(state, ownProps) {
  const { widget_reducer } = state;
  return {
    ...ownProps,
    outputs: widget_reducer.visualizer_input_output_values
      ? widget_reducer.visualizer_input_output_values.outputs
      : {},
    inputs: widget_reducer.visualizer_input_output_values
      ? widget_reducer.visualizer_input_output_values.inputs
      : {},
    decorate: widget_reducer.decorate,
    hide_outputs: widget_reducer.hide_outputs,
    variables_details: widget_reducer.visualizer_input_output_details,
    currency_conversion_rate: widget_reducer.currency_conversion_rate,
    currency_sign: widget_reducer.currency_sign,
  };
}

const mapDispatchToProps = (dispatch) => {
  return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(OutputsView);
